import { url } from 'inspector';
import { object, string, number, array ,date, InferType } from 'yup';

const GeneralRatesSchema = object({
    name: string(),
    //skill_sets: an,
    description: string()
})

export default GeneralRatesSchema